import type { SocialProfileNetworkType } from '@/types/socialProfileType';

import { THREADS, X } from '@/lib/socialProfile';

export const RESTRICTED_NETWORKS: SocialProfileNetworkType[] = [X, THREADS];
